var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "features-section" },
    [
      _c("h2", [_vm._v("What's in Premium?")]),
      _vm._v(" "),
      _vm._l(_vm.features, function(feature) {
        return _c("div", { key: feature.title, staticClass: "feature" }, [
          _c("div", { staticClass: "icon" }, [
            _c("span", { class: feature.icon })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [
            _c("h3", [_vm._v(_vm._s(feature.title))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(feature.description))])
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }